import React, { Component } from "react";
import "../../../../SCSS/setup.scss";
import "../../../../SCSS/services.scss";
import Axios from "axios";
import KenTable from "../../../../global_components/KenTable/kentable";
import { withRouter } from "react-router-dom";
import KenPaginationUI from "../../../../global_components/KenPaginator";
// import Loader from "../../../../../utils/loader/loaders";
import ServiceData from "./designation.json";
import KenForm from "../../../../global_components/KenForm/zqform";
import RestoreOutlinedIcon from "@material-ui/icons/RestoreOutlined";
// import HistoryIcon from "../../../../../assets/icons/history-icon.svg";
import NoteOutlinedIcon from "@material-ui/icons/NoteOutlined";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import moment from "moment";
// import ZqHistory from "../../../../../gigaLayout/change-history";
import { Drawer } from "rsuite";
import KenContainerNavbar from "../../../../global_components/KenContainerNav";
// import zq_api from "../../../../../utils/api-service";
import { Alert } from 'rsuite';
import Snackbar from '@material-ui/core/Snackbar';
class Designation extends Component {
  constructor(props) {
    super(props);
    // this.zq_api = new zq_api();
    this.state = {
      env: JSON.parse(localStorage.getItem("env")),
      useremail: localStorage.getItem("email"),
      channel: localStorage.getItem("channel"),
      BranchId: localStorage.getItem("branchid"),
      authToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI",
      orgId: "606ac70479dbb25447375fa8",
      orgName: localStorage.getItem("orgName"),
      userId: localStorage.getItem("userId"),
      username: localStorage.getItem("username"),
      tabview: true,
      preview: true,
      ServiceFormData: ServiceData,
      departmentName: "",
      noProg: "",
      loader: false,
      page: 1,
      limit: 10,
      totalRecord: 0,
      totalPages: 1,
      entityInstanceId: undefined,
      idosId: "",
      history: false,
      showHistory: false,
      historyData: [],
      submitCheck: false,
      designationId: '',
      containerNav: {
        isBack: false,
        name: "List of Designation",
        isName: true,
        isSearch: false,
        isSort: false,
        isPrint: true,
        isDownload: false,
        isShare: false,
        isNew: true,
        newName: "New",
        isSubmit: false,
      },
      tabData: [],
      departmentOptions: [],
      tableResponse: 'Fetching Details..',
      apiCall: false,
      addDesigId: "",
    };
  }
  componentDidMount() {
    this.getDesignations();
  }
  getDesignations = () => {
    this.setState({ loader: true });
    var headers = {
      'Authorization': "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI"
    }
    Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/designation?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}`, { headers: headers })
      .then(res => {
        console.log(res.data.data)
        if (res.data.status == 'success') {
          let tabData = [];
          let data = res.data.data;
          if (data.length > 0) {
            data.map(item => {
              let createdBy = "-"
              if (item.createdPersonInfo.length > 0) {
                createdBy = (String(item.createdPersonInfo[0].salutation).length > 1 ? (item.createdPersonInfo[0].salutation + ".") : "") + item.createdPersonInfo[0].firstName + " " + (item.createdPersonInfo[0].lastName != null ? String(item.createdPersonInfo[0].lastName).replace("-", "") : "")
              }
              tabData.push({
                'ID': item.id,
                "Designation Name": item.designation,
                "Department": item.departmentReferenceId != undefined ? item.departmentReferenceId.length > 0 ? item.departmentReferenceId[0].name : "-" : "-",
                "Description": item.description,
                "Created By": createdBy,
                "Version": String('V' + Number(item.__v + 1)),
                'Status': item.status != "" ? item.status != null ? item.status : "-" : "-",
                "Item": JSON.stringify(item)

              })
            })
            this.setState({
              loader: false,
              tabData: tabData,
              page: res.data.currentPage,
              limit: res.data.perPage,
              totalRecord: res.data.totalRecord,
              totalPages: res.data.totalPages
            });
          } if (data.length == 0) {
            this.setState({
              loader: false, tableResponse: 'No data '
            });
          }
        }
      }).catch(err => {
        this.setState({
          loader: false, tableResponse: 'No Data'
        });
      })
  }
  // componentWillMount() {
  //   // this.setState({ ServiceFormData: ServiceData }, () => {
  //   if (this.props.location.data != undefined) {
  //     // this.setState({ globalSearch: true }, () => {
  //     this.onPreviewServices(this.props.location.data);
  //     // })
  //   }
  //   // })
  // }

  CreateGoods = () => {
    this.setState({ tabview: false });
  };


  onSubmit = (data, item) => {
    console.log("dataitem", data, item)
    let userData = this.state.ServiceFormData;
    let apiNewCall = true;
    userData.map(item => {
      if (item.requiredBoolean) {
        if (item['defaultValue'] === "" || item['defaultValue'] === undefined || item['error'] || item['defaultValue'] == null) {
          item["error"] = true;
          item["validation"] = true
          item['errorMsg'] = `Invalid ${item.label}`
          apiNewCall = false
        } else {
          item["error"] = false;
          item["validation"] = false;
        }
      }
    })
    this.setState({ ServiceFormData: userData }, () => {
      if (apiNewCall) {
        this.setState({ loader: true }, () => {
          let payloadInput = {}
          this.state.ServiceFormData.map(item => {
            if (item.type != "heading" && item.category != "button") {
              payloadInput[item.name] = item.defaultValue
            }
          })
          let payload = {
            "id": String(payloadInput.ID),
            "name": payloadInput.Name,
            "description": payloadInput.description,
            "departmentReferenceId": payloadInput.type,
            "createdBy": this.state.userId,
            "updatedBy": this.state.userId,
            "status": "Active",
          }
          console.log("payloadInput", payload)
          var headers = {
            'Authorization': localStorage.getItem('auth_token')
          }
          if (!this.state.apiCall) {
            Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/designation`, payload, { headers: headers })
              .then(res => {
                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                  setTimeout(() => {
                    this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
                      this.getDesignations();
                    })
                  }, 2000)
                })
              }).catch(err => {
                this.setState({
                  loader: false
                }, () => {
                  this.setState({ snackBar: true, processMessage: err }, () => {
                    setTimeout(() => {
                      this.setState({ snackBar: false }, () => {
                      })
                    }, 2000)
                  })
                });
              })
          }
          else {
            Axios.put(`https://api.zenqore.com/payroll/uat/hkbk/masters/designation?id=${this.state.entityInstanceId}`, payload, { headers: headers })
              .then(res => {
                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                  setTimeout(() => {
                    this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
                      this.getDesignations();
                    })
                  }, 2000)
                })
              }).catch(err => {
                this.setState({
                  loader: false
                }, () => {
                  this.setState({ snackBar: true, processMessage: err }, () => {
                    setTimeout(() => {
                      this.setState({ snackBar: false }, () => {
                      })
                    }, 2000)
                  })
                });
              })
          }
        })
      }

    })

  }
  onPreviewServices = (item) => {
    this.getDepartment(true, item);
  };
  onPaginationChange = (page, limit) => {
    this.setState({ page: page, limit: limit }, () => {
      this.getDesignations();
    });
  };
  resetform = () => {
    let ServiceFormData = this.state.ServiceFormData;
    ServiceFormData.map((item) => {
      item["defaultValue"] = undefined;
      item["readOnly"] = false;
      item["error"] = false;
      item["required"] = item.requiredBoolean
      item["validation"] = false
    });
    this.setState(ServiceFormData);
  };

  getDepartment = (preview, item) => {
    this.setState({ loader: true })
    let config = {
      headers: {
        "Authorization": this.state.authToken,
        'Content-Type': 'application/json'
      }
    }
    Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/department?org=${this.state.orgId}`, config)
      .then(resDept => {
        console.log(resDept.data.data)
        let departmentOptions = [];
        if (resDept.data.status == 'success') {
          resDept.data.data.map(item => {
            departmentOptions.push({
              label: item.name,
              value: item._id
            })
          })
          let ServiceFormData = this.state;
          this.setState({ ServiceFormData: ServiceData }, () => {
            ServiceData.map((item) => {
              if (item.name == "type") {
                item.options = departmentOptions
                item["error"] = false;
                item["required"] = item.requiredBoolean
                item["validation"] = false
              }
              else {
                item.defaultValue = item.defaultValue
              }
            })
            if (preview) {
              let ServiceFormData = this.state.ServiceFormData;
              let details = JSON.parse(item.Item);
              let objKeys = Object.keys(details);
              let entityInstanceId = details["_id"];
              let designationId = details.id
              console.log("details", details);

              this.setState({ tabview: false, preview: true, apiCall: true, entityInstanceId: entityInstanceId, designationId });

              ServiceFormData.map((item) => {
                // let keyName = key.toLowerCase().replace(/ /g, "");
                // let name = String(details['Department Head']).split()
                if (item.name == "ID") {
                  item["defaultValue"] = details['id'];
                  item["readOnly"] = false;
                  item["required"] = false;
                }
                else if (item.name == "Name") {
                  item["defaultValue"] = details['designation'];
                  item["readOnly"] = false;
                  item["required"] = false;
                }
                else if (item.name == "type") {
                  item["defaultValue"] = details['departmentReferenceId'].length > 0 ? details['departmentReferenceId'][0]['_id'] : null
                  item["readOnly"] = false;
                  item["required"] = false;
                }
                else if (item.name == "description") {
                  item["defaultValue"] = details['description'];
                  item["readOnly"] = false;
                  item["required"] = false;
                }

              })
              this.setState({ ServiceFormData, loader: false });
            } else {

              this.setState({ tabview: false, preview: false, loader: false });
            }
          });
        }
      }).catch(err => {
        console.log("err", err)
      })
  }

  onAddServices = () => {

    this.setState({ apiCall: false }, () => {
      this.resetform();

      let ServiceFormData = this.state.ServiceFormData;
      this.setState({ loader: true }, () => {
        var headers = {
          'Authorization': "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI"
        }
        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/payroll/generateNextId?type=DESG&collection=designations`, { headers: headers })
          .then(res => {
            console.log(res.data.data)
            this.getDepartment(false, undefined);
            let addDesigId = res.data.data;
            ServiceFormData.map((item) => {
              if (item.name == 'ID') {
                item["defaultValue"] = res.data.data;
                item["readOnly"] = true;
                item["error"] = false;
                item["required"] = item.requiredBoolean
                item["validation"] = false
              }
            });

            this.setState({ ServiceFormData: ServiceFormData, addDesigId }, () => {
              this.getDepartment(false, undefined);
            });

          }).catch(err => {
            this.setState({
              loader: false
            });
          })
      });


    })

  };
  handleBack = () => {
    if (this.props.location.status != "active") {
      this.resetform();
      this.setState({ tabview: true });
    } else {
      this.props.history.goBack();
    }
  };

  onInputChanges = (value, item, e, dataS) => {
    console.log("value", value)
    console.log("item", item)
    console.log("e", e)
    console.log("dataS", dataS)
    if (dataS != undefined) {
      if (dataS["name"] === "type") {
        dataS["defaultValue"] = value;

      }
    }
    else {
      item["defaultValue"] = value
    }

  }

  formBtnHandle = (item) => {
    return item.type === "clear" ? this.cleartabData() : this.canceltabData();
  };


  cleartabData = () => {
    let issueDetailData = [];
    let formData = this.state.ServiceFormData;
    this.setState({ ServiceFormData: [] }, () => {
      formData.map((item) => {
        item["defaultValue"] = undefined;
        item["readOnly"] = false;
        if (item.required) {
          item["validation"] = false;
        }
      });
      issueDetailData = formData;
      console.log(issueDetailData, "issueDetailData");
      this.setState({
        ServiceFormData: issueDetailData,
      });
    });
  };
  canceltabData = () => {
    this.resetform();
    this.setState({ tabview: true });
  };
  // getChangeHistory = (entityInstanceId) => {
  //   Axios.get(
  //     `${this.state.env["zqBaseUri"]}/master/changeHistory/getChangeHistory?org=${this.state.orgId}&entity=services&entityInstanceId=${entityInstanceId}`
  //   )
  //     .then((response) => {
  //       let api_data = response.data;
  //       let historyData = [];
  //       api_data.sort((data1, data2) => {
  //         return Number(data2.created_at) - Number(data1.created_at);
  //       });
  //       api_data.map((item) => {
  //         let date = new Date(
  //           new Intl.DateTimeFormat("en-US", {
  //             month: "2-digit",
  //             day: "numeric",
  //             year: "numeric",
  //             hour: "2-digit",
  //             minute: "2-digit",
  //           }).format(item["created_at"])
  //         );
  //         let descriptionData = item.description["0"]
  //           .split(",")
  //           .map((desc, i) => {
  //             return (
  //               <p key={i}>
  //                 <div style={{ display: "flex" }}>
  //                   <span className="span-hist" style={{ width: "5%" }}>
  //                     -
  //                   </span>
  //                   {desc}
  //                 </div>
  //               </p>
  //             );
  //           });
  //         console.log(descriptionData);
  //         historyData.push({
  //           description: descriptionData,
  //           time: moment(date).format("hh:mm"),
  //           created_at: item["created_at"]
  //             ? moment(date).format("DD/MM/YYYY (hh:mm A)")
  //             : "-",
  //           version: item.version,
  //           btn: false,
  //         });
  //       });
  //       this.setState({ historyData: historyData });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // showHistory = () => {
  //   this.setState({ history: true, showHistory: true });
  // };
  // onCloseForm = () => {
  //   this.setState({ showHistory: false });
  // };
  render() {
    return (
      <React.Fragment>
        {/* {this.state.loader ? <Loader /> : null} */}
        <div className="setup-page-wrapper">
          {this.state.tabview ? (
            <React.Fragment>

              {this.state.containerNav == undefined ? null : (
                <React.Fragment>
                  <KenContainerNavbar
                    containerNav={this.state.containerNav}
                    onAddNew={() => {
                      this.resetform();
                      this.onAddServices();
                    }}
                  />
                  <div className="print-time">{this.state.printTime}</div>
                </React.Fragment>

              )}
              <div className="trial-balance-header-title">
                <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                  marginRight: '5px',
                  cursor: 'pointer',
                  marginTop: '0px'
                }} />
                <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| Designation</p>
              </div>
              <div
                className="table-wrapper"
                style={{ marginTop: "10px" }}
              >
                {this.state.tabData.length == 0 ||
                  this.state.loader ? (
                  <p className="noprog-txt">{this.state.tableResponse}</p>
                ) : (
                  <React.Fragment>
                    <div className="remove-last-child-table">
                      <KenTable
                        data={this.state.tabData}
                        rowClick={(item) => {
                          this.onPreviewServices(item);
                        }}
                      />
                    </div>
                  </React.Fragment>
                )}
                <div className="setup-pagination">
                  {this.state.tabData.length !== 0 && (
                    <KenPaginationUI
                      total={this.state.totalRecord}
                      onPaginationApi={this.onPaginationChange}
                      totalPages={this.state.totalPages}
                      limit={this.state.limit}
                    />
                  )}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="tab-form-wrapper">
                <div className="goods-btns services-btns">
                  <div className="preview-header-wrap">
                    <div className="trial-balance-header-title">
                      <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.handleBack() }} style={{
                        marginRight: '5px',
                        cursor: 'pointer',
                        marginTop: '0px'
                      }} />
                      {this.state.preview ?
                        <p className="top-header-title" onClick={() => { this.handleBack() }}>| Designation | {this.state.designationId}</p> :
                        <p className="top-header-title" onClick={() => { this.handleBack() }}>| Designation | {this.state.addDesigId}</p>}
                    </div>
                    {/* {this.state.preview ? (
                        <React.Fragment>
                          <div
                            className="active-status-wrapper"
                            style={{ marginLeft: "10px" }}
                          >
                            <p className="active-status-content">Active</p>
                          </div>
                        </React.Fragment>
                      ) : null} */}
                  </div>
                  {/* <div className="notes-history-wrapper">
                    {this.state.preview ? (
                      <div
                        className="history-icon-box"
                        title="View History"
                        onClick={this.showHistory}
                      >
                        <img src={HistoryIcon} /> <p>Change History</p>
                      </div>
                    ) : null}
                  </div> */}
                </div>
                <div className="goods-wrapper service-wrapper form-heading-tab">

                  <KenForm
                    formData={this.state.ServiceFormData}
                    className="goods-wrap"
                    onInputChanges={this.onInputChanges}
                    onFormBtnEvent={(item) => {
                      this.formBtnHandle(item);
                    }}
                    clear={true}
                    onSubmit={this.onSubmit}
                  />
                </div>
                {/* <div className="notes-history-wrapper">
                    {this.state.preview ? (
                      <div
                        className="history-icon-box"
                        title="View History"
                        onClick={this.showHistory}
                      >
                        <img src={HistoryIcon} /> <p>Change History</p>
                      </div>
                    ) : null}
                  </div> */}
              </div>
            </React.Fragment>
          )}
        </div>
        {/* {this.state.history ? (
          <Drawer show={this.state.showHistory} onHide={this.close}>
            <ZqHistory
              historyData={this.state.historyData}
              onCloseForm={this.onCloseForm}
            />
          </Drawer>
        ) : null} */}
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.snackBar}
          autoHideDuration={1000}
          message={this.state.processMessage}
          className="success-snackbar"

        />
      </React.Fragment>
    );
  }
}
export default withRouter(Designation);
